import React from 'react';
import { useOptions } from '../HRContext';
import { Select } from './Controls';

// a select over one lookup (employees, departments, sites …), as Stephanet's Picker
export default function Picker({ lookup = 'employees', value, onChange, placeholder, className = 'picker' }) {
  const options = useOptions(lookup);
  return (
    <Select className={className} value={value || ''} onChange={e => onChange(e.target.value)}>
      <option value="">{placeholder || 'Select…'}</option>
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </Select>
  );
}
